import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import Select, { SelectOption } from '../Select';
import { isDefinedAndNotEmpty, getObjectFromString } from 'utils';

const RemoteSelect = (props) => {
  const [options, setOptions] = useState();

  const {
    keyName,
    valueKeyName,
    labelKeyName,
    relatedKey,
    disabled,
    defaultKey,
    defaultOptions,
    defaultValue,
    url,
    objectKey,
    dataSource,
    related,
    filterOption,
    filterType,
    onRequestEnd,
    extraValues,
    labelKeyDesc,
    labelDescCreator,
    showSearch,
    valueType,
    ...otherProps
  } = props;

  const isMountedRef = useRef(true);

  useEffect(() => {
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  useEffect(() => {
    if (isDefinedAndNotEmpty(url)) {
      getOptions(url, related, true);
    } else {
      getOptionsWithOutUrl();
    }
  }, [url, related, relatedKey, dataSource, defaultOptions, filterType]);

  const getOptionsWithOutUrl = () => {
    setOptions(
      objectKey ? getObjectFromString(objectKey, dataSource) : dataSource
    );
  };

  const getOptions = (url, related, initial) => {
    const { onChange } = props;
    const relatedValue = isDefinedAndNotEmpty(related)
      ? typeof related === 'object'
        ? related.key
        : related
      : null;
    if (relatedKey && !isDefinedAndNotEmpty(relatedValue)) {
      setOptions([], () => {
        if (!initial) onChange();
      });
    }
  };

  const selectFilterOptions = (inputValue, option) => {
    const label = option.props.label;
    if (filterOption) return filterOption(inputValue, option);
    if (!isDefinedAndNotEmpty(inputValue) || !isDefinedAndNotEmpty(label))
      return true;

    return label.toLowerCase().indexOf(inputValue.toLowerCase()) !== -1;
  };

  const disabledProp = disabled === true ? true : relatedKey ? !related : false;
  const optionSelectors =
    options &&
    options
      .filter(
        (item) =>
          isDefinedAndNotEmpty(getObjectFromString(labelKeyName, item)) &&
          isDefinedAndNotEmpty(getObjectFromString(valueKeyName, item))
      )
      .map((item, index) => {
        let labelDesc;

        if (typeof labelDescCreator === 'function') {
          labelDesc = labelDescCreator(item);
        } else if (labelKeyDesc) {
          labelDesc = `- ${getObjectFromString(labelKeyDesc, item).toString()}`;
        }

        const label =
          getObjectFromString(labelKeyName, item).toString() ||
          getObjectFromString(valueKeyName, item).toString();

        let extraAttr = {};
        extraValues !== undefined &&
          extraValues !== null &&
          !!Object.keys(extraValues).length > 0 &&
          extraValues.map((valueItem) => {
            return (extraAttr = { ...extraAttr, [valueItem]: item[valueItem] });
          });

        return (
          <SelectOption
            {...extraAttr}
            key={keyName ? getObjectFromString(keyName, item) : index}
            value={
              // eslint-disable-next-line eqeqeq
              valueType == 'object'
                ? JSON.stringify({
                    [related]: getObjectFromString(
                      valueKeyName,
                      item
                    ).toString(),
                  })
                : getObjectFromString(valueKeyName, item).toString()
            }
            label={label}
            desc={labelDesc}
          >
            {label} {labelDesc && labelDesc}
          </SelectOption>
        );
      });
  return (
    <Select
      {...otherProps}
      key={defaultValue || defaultKey}
      disabled={disabledProp}
      defaultValue={defaultValue}
      showSearch={showSearch}
      filterOption={selectFilterOptions}
    >
      {optionSelectors}
    </Select>
  );
};

RemoteSelect.defaultProps = {
  valueKeyName: 'value',
  labelKeyName: 'label',
  defaultKey: 'remoteSelect',
  objectKey: 'visible_values',
};

RemoteSelect.propTypes = {
  className: PropTypes.string,
  url: PropTypes.string,
  dataSource: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  related: PropTypes.any,
  relatedKey: PropTypes.string,
  objectKey: PropTypes.string,
  valueKeyName: PropTypes.string,
  labelKeyName: PropTypes.string,
  keyName: PropTypes.string,
  disabled: PropTypes.bool,
  filterOption: PropTypes.func,
  filterType: PropTypes.string,
  onRequestEnd: PropTypes.func,
  extraValues: PropTypes.array,
  labelKeyDesc: PropTypes.string,
  labelDescCreator: PropTypes.func,
};

export default RemoteSelect;



// WEBPACK FOOTER //
// ./src/plugins/tfs/pages/oms/PackageOrderDetail/modals/manuelPackage/RemoteSelect/index.js